/**
 * Calculates the end time based on start time and duration in hours
 * @param startTime - Time in HH:MM format (e.g., "14:00")
 * @param hours - Duration in hours
 * @returns End time in HH:MM format
 */
export const calculateEndTime = (startTime: string, hours: number): string => {
  const start = new Date(`1970-01-01T${startTime}`);
  const end = new Date(start.getTime() + (hours * 60 * 60 * 1000));
  return end.toTimeString().slice(0, 5);
};

/**
 * Calculates the end time with proper day overflow handling (23h + 2h = 1h)
 * @param startTime - Time in HH:MM format (e.g., "14:00")
 * @param hours - Duration in hours (can be decimal)
 * @returns End time in HH:MM format
 */
export const calculateEndTimeWithDayOverflow = (startTime: string, hours: number): string => {
  if (!startTime || hours < 0) return startTime;
  
  const [startHour, startMinute] = startTime.split(':').map(Number);
  
  // Convert everything to minutes for precise calculation
  const startTotalMinutes = startHour * 60 + startMinute;
  const additionalMinutes = Math.round(hours * 60); // Round to avoid floating point precision issues
  const endTotalMinutes = startTotalMinutes + additionalMinutes;
  
  // Calculate final hour and minute with 24h overflow handling
  const endHour = Math.floor(endTotalMinutes / 60) % 24;
  const endMinute = endTotalMinutes % 60;
  
  // Format with leading zeros
  return `${endHour.toString().padStart(2, '0')}:${endMinute.toString().padStart(2, '0')}`;
};